import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconLink1 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24.406 24.4'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M22.795,9.397 L20.584,11.608 C19.542,12.649 18.158,13.222 16.686,13.222 L16.263,13.222 C15.701,13.222 15.245,12.767 15.245,12.205 C15.245,11.642 15.701,11.187 16.263,11.187 L16.686,11.187 C17.614,11.187 18.488,10.825 19.145,10.169 L21.356,7.958 C22.013,7.299 22.374,6.426 22.374,5.496 C22.374,4.568 22.013,3.694 21.356,3.036 C19.999,1.681 17.793,1.681 16.436,3.036 L14.226,5.248 C13.569,5.905 13.207,6.780 13.207,7.709 L13.207,8.124 C13.207,8.687 12.751,9.143 12.189,9.143 C11.627,9.143 11.171,8.687 11.171,8.124 L11.171,7.709 C11.171,6.237 11.745,4.852 12.785,3.809 L14.997,1.597 C17.147,-0.552 20.646,-0.552 22.795,1.597 C23.837,2.638 24.410,4.023 24.410,5.496 C24.410,6.970 23.837,8.354 22.795,9.397 ZM8.120,17.287 C7.860,17.287 7.600,17.187 7.401,16.989 C7.003,16.591 7.003,15.947 7.401,15.549 L15.544,7.405 C15.941,7.007 16.585,7.007 16.983,7.405 C17.380,7.802 17.380,8.447 16.983,8.844 L8.840,16.989 C8.641,17.187 8.381,17.287 8.120,17.287 ZM8.126,13.210 L7.705,13.210 C6.777,13.210 5.902,13.572 5.244,14.228 L3.034,16.440 C1.679,17.796 1.678,20.005 3.034,21.361 C4.390,22.715 6.598,22.715 7.955,21.361 L10.165,19.150 C10.822,18.491 11.184,17.618 11.184,16.688 L11.184,16.271 C11.184,15.708 11.640,15.253 12.202,15.253 C12.764,15.253 13.220,15.708 13.220,16.271 L13.220,16.688 C13.220,18.161 12.646,19.546 11.605,20.589 L9.394,22.800 C8.319,23.875 6.906,24.412 5.494,24.412 C4.082,24.412 2.670,23.875 1.595,22.800 C-0.554,20.651 -0.554,17.152 1.594,15.000 L3.805,12.789 C4.848,11.747 6.233,11.174 7.705,11.174 L8.126,11.174 C8.689,11.174 9.144,11.629 9.144,12.192 C9.144,12.754 8.689,13.210 8.126,13.210 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconLink1.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
